module.exports = __webpack_public_path__ + "img/envelope-6.07603696.svg";